import { NavigationPath } from "@/router/navigation-path";
import { PackageMappings } from "@/screens/dashboard/dashboard.types.ts";

const TIME_UNITS = {
  SECOND: "second",
  MINUTE: "minute",
  HOUR: "hour",
  DAY: "day",
  MONTH: "month",
  YEAR: "year",
} as const;

type TimeUnit = (typeof TIME_UNITS)[keyof typeof TIME_UNITS];

interface TimeConfig {
  unit: TimeUnit;
  threshold: number;
  format: string;
}

export const TIME_CONFIGS: TimeConfig[] = [
  { unit: TIME_UNITS.YEAR, threshold: 31536000, format: "yıl önce" },
  { unit: TIME_UNITS.MONTH, threshold: 2592000, format: "ay önce" },
  { unit: TIME_UNITS.DAY, threshold: 86400, format: "gün önce" },
  { unit: TIME_UNITS.HOUR, threshold: 3600, format: "saat önce" },
  { unit: TIME_UNITS.MINUTE, threshold: 60, format: "dakika önce" },
  { unit: TIME_UNITS.SECOND, threshold: 0, format: "saniye önce" },
];

export const PACKAGE_MAPPINGS: PackageMappings = {
  COACH: ["3020", "3021", "3022", "3023"],
  GOT_IT: ["3010", "3011", "3012", "3013", "3015", "3014"],
  SOLVER: ["3000", "3001", "3002"],
} as const;

export const PPPNames = {
  SOLVER: "SOLVER",
  COACH: "COACH",
  COACHING: "COACHING",
  GOT_IT: "GOT_IT",
};

export const PackageType = {
  MEETING: "MEETING",
  MOMENTARY: "MOMENTARY",
} as const;

export type PackageType = (typeof PackageType)[keyof typeof PackageType];

export const LanguageCodes = {
  TR: "tr-TR",
};

export const SERVICE_RESULT = {
  SUCCESS: "Success",
  ERROR: "Error",
};

export const ENVs = {
  asseturl: process.env.STATIC_CDN,
};

export const PRIVATE_ROUTES: string[] = [NavigationPath.dashboard];

export const DEVELOPMENT_MODE: boolean = process.env.MODE === "dev";
